import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const messages = [{
  name: 'Sarah',
  location: 'Dallas'
}, {
  name: 'Emily',
  location: 'Austin'
}, {
  name: 'Sofia',
  location: 'Los Angeles'
}, {
  name: 'Jessica',
  location: 'Miami'
}, {
  name: 'Amanda',
  location: 'Chicago'
}, {
  name: 'Rachel',
  location: 'Denver'
}, {
  name: 'Chloe',
  location: 'Portland'
}, {
  name: 'Michelle',
  location: 'Atlanta'
}, {
  name: 'Lauren',
  location: 'Nashville'
}, {
  name: 'Olivia',
  location: 'Phoenix'
}];
const actions = ['just purchased', 'just got instant access', 'just unlocked the reset', 'just started her reset'];
function getRandomMinutesAgo() {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `${mins} min ago`;
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState({
    name: '',
    location: '',
    action: '',
    time: ''
  });
  const showCountRef = useRef(0);
  const hasTriggeredRef = useRef(false);
  const usedIndicesRef = useRef<number[]>([]);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const getNextMessage = useCallback(() => {
    let idx: number;
    if (usedIndicesRef.current.length >= messages.length) {
      usedIndicesRef.current = [];
    }
    do {
      idx = Math.floor(Math.random() * messages.length);
    } while (usedIndicesRef.current.includes(idx));
    usedIndicesRef.current.push(idx);
    const msg = messages[idx];
    const action = actions[Math.floor(Math.random() * actions.length)];
    return {
      name: msg.name,
      location: msg.location,
      action,
      time: getRandomMinutesAgo()
    };
  }, []);
  const showNextNotification = useCallback(() => {
    if (showCountRef.current >= 5) return;
    setCurrent(getNextMessage());
    setIsVisible(true);
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
      showCountRef.current += 1;
      if (showCountRef.current < 5) {
        const delay = 45000 + Math.random() * 15000;
        timeoutRef.current = setTimeout(() => {
          showNextNotification();
        }, delay);
      }
    }, 5000);
  }, [getNextMessage]);
  const triggerNotification = useCallback(() => {
    if (hasTriggeredRef.current) return;
    hasTriggeredRef.current = true;
    showNextNotification();
  }, [showNextNotification]);
  useEffect(() => {
    const handleScroll = () => {
      if (hasTriggeredRef.current) return;
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
      if (scrollPercent > 50) {
        triggerNotification();
      }
    };
    const lingerTimer = setTimeout(() => {
      triggerNotification();
    }, 20000);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(lingerTimer);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [triggerNotification]);
  return <AnimatePresence data-id="element-164">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed bottom-5 left-4 z-50 bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-sand p-3 flex items-center gap-3 max-w-[320px]" data-id="element-165">
          <div className="w-11 h-11 rounded-lg overflow-hidden shrink-0 shadow-sm" data-id="element-166">
            <img src="https://cdn.magicpatterns.com/uploads/wkZSzuyJiLzekd5DqSr7dv/MP_Mockup_-_The_Nervous_System_Reset.png" alt="Product" className="w-full h-full object-cover" data-id="element-167" />
          </div>
          <div className="min-w-0" data-id="element-168">
            <p className="text-[13px] text-charcoal font-medium leading-snug" data-id="element-169">
              {current.name} from {current.location} {current.action}
            </p>
            <p className="text-[11px] text-charcoal-light/70 mt-0.5" data-id="element-170">
              {current.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}